import { render, staticRenderFns } from "./BrickAndSubstructure.vue?vue&type=template&id=6f2f35eb&scoped=true"
import script from "./BrickAndSubstructure.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f35eb",
  null
  
)

export default component.exports